import { Components, Theme } from '@mui/material/styles';

export const MuiContainer: Components<Theme>['MuiContainer'] = {
  defaultProps: {
    disableGutters: true,
    maxWidth: false,
  },
};
